<script setup>
import { onMounted, ref } from 'vue'
import axios from 'axios'

const player = ref(null)
const streamData = ref(null)
const playerConfig = ref({
  source: "",
  mimeType: "",
  parentId: '#player',
  autoplay: true,
  poster: 'https://cdn1.jskhdkajskjsad.xyz/wp-content/uploads/2025/05/ng3.gif',
  watermark: [],
  plugins: [],
  ads: {},
  width: '100%',
  height: '100%',
  // mediaControl: {
  //   autoHide: true,
  //   autoHideTime: 3000,
  //   buttons: ['playpause', 'volume', 'fullscreen']
  // }
})

// Configuration object
const webconfig = {
  banner_img: '',
  banner_link: '',
  banner_title: '',
  banner_alt: '',
  banner_rel: '',
  allow_direct: true,
  allow_domain: '',
  analytic: '',
  corsbypass: '',
  player_poster: '',
  player_watermark: '',
  player_watermark_link: '',
  endpoint: ''
}

const loadScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    // Handle production paths
    const scriptPath = import.meta.env.PROD 
      ? src.replace('/src/assets/', '/assets/') 
      : src
    script.src = scriptPath
    script.onload = () => {
      console.log(`Successfully loaded script: ${scriptPath}`)
      resolve()
    }
    script.onerror = (error) => {
      console.error(`Failed to load script: ${scriptPath}`, error)
      reject(error)
    }
    document.head.appendChild(script)
  })
}

// Default configurations
const defaultAdsConfig = {
  preRoll: {
    enabled: true,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    skip: true,
    timeout: 5,
    link: 'http://example.com/ad-destination',
    autoskip: 20,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  midRoll: {
    enabled: true,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    interval: 4,
    skip: true,
    timeout: 15,
    autoskip: 15,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  postRoll: {
    enabled: false,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    link: 'http://example.com/ad-destination',
    autoskip: 8,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  text: {
    wait: 'Wait % seconds...',
    skip: 'Skip >'
  }
}

const defaultPoster = 'https://cdn1.jskhdkajskjsad.xyz/wp-content/uploads/2025/05/ng3.gif'

const defaultWatermarkConfig = [
  {
    imageUrl: 'https://gudangmt.sgp1.cdn.digitaloceanspaces.com/oke1.png',
    imageLink: 'https://github.com/clappr/clappr',
    position: 'top-right'
  },
  {
    imageUrl: 'https://gudangmt.sgp1.cdn.digitaloceanspaces.com/s1.gif',
    imageLink: 'https://github.com/clappr/clappr',
    position: 'bottom-center',
    className: 'animated-watermark'
  }
]

// Function to load Histats tracking
const loadHistatsTracking = (trackingId) => {
  // Remove any existing Histats scripts
  const existingScripts = document.querySelectorAll('script[src*="histats.com"]')
  existingScripts.forEach(script => script.remove())
  
  // Remove any existing noscript elements
  const existingNoscript = document.querySelector('noscript img[src*="histats.com"]')
  if (existingNoscript) {
    existingNoscript.parentElement.remove()
  }

  // Create and append the Histats script
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.innerHTML = `
    var _Hasync = _Hasync || [];
    _Hasync.push(['Histats.start', '1,${trackingId},4,0,0,0,00010000']);
    _Hasync.push(['Histats.fasi', '1']);
    _Hasync.push(['Histats.track_hits', '']);
    (function() {
      var hs = document.createElement('script'); hs.type = 'text/javascript'; hs.async = true;
      hs.src = ('//s10.histats.com/js15_as.js');
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(hs);
    })();
  `
  document.head.appendChild(script)

  // Create and append the noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.src = `//sstatic1.histats.com/0.gif?${trackingId}&101`
  img.alt = ''
  img.border = '0'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// Function to load StatCounter tracking
const loadStatCounterTracking = (project, security) => {
  // Remove any existing StatCounter scripts
  const existingScripts = document.querySelectorAll('script[src*="statcounter.com"]')
  existingScripts.forEach(script => script.remove())

  // Create and append the StatCounter script
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.innerHTML = `
    var sc_project = ${project};
    var sc_invisible = 1;
    var sc_security = "${security}";
    var sc_remove_link = 1;
  `
  document.head.appendChild(script)

  // Create and append the StatCounter tracking script
  const trackingScript = document.createElement('script')
  trackingScript.type = 'text/javascript'
  trackingScript.src = 'https://www.statcounter.com/counter/counter.js'
  trackingScript.async = true
  document.head.appendChild(trackingScript)

  // Create and append the noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.src = `https://c.statcounter.com/${project}/0/${security}/1/`
  img.alt = ''
  img.border = '0'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

// Function to load Google Analytics tracking
const loadGoogleAnalyticsTracking = (trackingId) => {
  // Remove any existing GA scripts
  const existingScripts = document.querySelectorAll('script[src*="googletagmanager.com"]')
  existingScripts.forEach(script => script.remove())

  // Create and append the GA script
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
  document.head.appendChild(script)

  // Initialize GA
  window.dataLayer = window.dataLayer || []
  function gtag() {
    dataLayer.push(arguments)
  }
  gtag('js', new Date())
  gtag('config', trackingId)
}

// Load ads configuration from JSON file
const loadAdsConfig = async () => {
  try {
    const response = await fetch('/ads-config.json')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const config = await response.json()
    
    // Validate and merge ads config
    playerConfig.value.ads = {
      ...defaultAdsConfig,
      ...config,
      preRoll: { 
        ...defaultAdsConfig.preRoll, 
        ...config.preRoll,
        title: config.preRoll?.title?.enabled ? config.preRoll.title : { enabled: false }
      },
      midRoll: { 
        ...defaultAdsConfig.midRoll, 
        ...config.midRoll,
        title: config.midRoll?.title?.enabled ? config.midRoll.title : { enabled: false }
      },
      postRoll: { 
        ...defaultAdsConfig.postRoll, 
        ...config.postRoll,
        title: config.postRoll?.title?.enabled ? config.postRoll.title : { enabled: false }
      },
      text: { ...defaultAdsConfig.text, ...config.text }
    }
    
    // Validate and set watermark from config
    playerConfig.value.watermark = config.watermark || defaultWatermarkConfig

    // Set poster from config
    playerConfig.value.poster = config.poster || defaultPoster

    // Set watermark timing settings
    playerConfig.value.watermarkTimeout = config.watermarkTimeout || 3000
    playerConfig.value.watermarkVisibility = config.watermarkVisibility || 6000
    playerConfig.value.enableInitialDelay = config.enableInitialDelay || false

    // Load tracking scripts if enabled
    if (config.tracking?.histats?.enabled) {
      loadHistatsTracking(config.tracking.histats.id)
    }
    
    if (config.tracking?.statcounter?.enabled) {
      loadStatCounterTracking(config.tracking.statcounter.project, config.tracking.statcounter.security)
    }
    
    if (config.tracking?.googleAnalytics?.enabled) {
      loadGoogleAnalyticsTracking(config.tracking.googleAnalytics.id)
    }
    
    console.log('Configuration loaded:', playerConfig.value)
  } catch (error) {
    console.warn('Failed to load configuration, using defaults:', error)
    // Use default configurations
    playerConfig.value.ads = defaultAdsConfig
    playerConfig.value.watermark = defaultWatermarkConfig
    playerConfig.value.poster = defaultPoster
    playerConfig.value.watermarkTimeout = 3000
    playerConfig.value.watermarkVisibility = 6000
    playerConfig.value.enableInitialDelay = false
  }
}

// Initialize player after component is mounted
onMounted(async () => {
  try {
    // Load ads configuration first
    await loadAdsConfig()
    
    // Load Clappr core first
    await loadScript('/src/assets/js/core/clappr.js')
    console.log('Clappr core loaded')
    
    // Then load ads plugin
    await loadScript('/src/assets/js/clappr.ads.js')
    console.log('Ads plugin loaded')
    
    // Now that scripts are loaded, update player config with plugins
    if (window.ClapprAds) {
      playerConfig.value.plugins = [window.ClapprAds]
      console.log('Ads plugin configured')
    } else {
      console.error('Ads plugin not found')
    }

    // Continue with your existing onMounted code
    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.has('type') && urlParams.has('src')) {
      const type = urlParams.get('type')
      const src = urlParams.get('src')

      switch (type) {
        case 'flv':
          playFlv(src)
          break
        case 'iframe':
          playIframe(atob(src))
          break
        case 'hls':
          const realUrl = atob(src)
          realUrl.includes('.sdp') ? playSdp(atob(src)) : playNormal(atob(src))
          break
        default:
          playNormal(atob(src))
      }
    } else if (urlParams.has('server') && urlParams.has('param')) {
      const server = urlParams.get('server')
      const param = urlParams.get('param')

      switch (server) {
        case 'alpha':
          axios.get(`https://v1.mirrorstream.xyz/hls365.php?id=${param}&mode=sources`)
            .then(response => {
              playHls(response.data, webconfig)
            })
            .catch(error => {
              console.error(error)
            })
          break
        case 'charlie':
          axios.get(`${webconfig.corsbypass}https://api.mirrorstream.xyz/charlie/json/${param}.json`)
            .then(response => {
              const playerElement = document.getElementById('player')
              playerElement.innerHTML = `<video id="example-video" class="video-js vjs-default-skin" data-setup='{"fluid": true,"autoplay":true,"muted":true}' controls>
                <source src="${webconfig.corsbypass}${response.data.videoHls}" type="application/x-mpegURL">
              </video>`
              playNormalVideoJs(response.data.videoHls)
            })
            .catch(error => {
              console.error(error)
            })
          break
        case 'delta':
          axios.get(`${webconfig.corsbypass}https://api.mirrorstream.xyz/delta/json/${param}.json`)
            .then(response => {
              playHls(response.data.videoHls, webconfig)
            })
            .catch(error => {
              console.error(error)
            })
          break
        case 'beta':
          axios.get(`https://cors.livestreamapi.xyz/https://streamdata.apk150.pro/streamdata/${param}.json`)
            .then(response => {
              streamData.value = response.data.sources
              streamData.value[0].type === 'iframe'
                ? playIframe(streamData.value[0].source)
                : playNormal(streamData.value[0].source)
            })
            .catch(error => {
              console.error(error)
            })
          break
      }
    }
  } catch (error) {
    console.error('Failed to load Clappr scripts:', error)
  }
})

async function loadFlvScripts() {
  try {
    // Load FLV.js
    await loadScript('/src/assets/js/flv/flv.min.js')
    console.log('FLV.js loaded')
    
    // Load FLV.js playback plugin
    await loadScript('/src/assets/js/flv/clappr-flvjs-playback.min.js')
    console.log('FLV.js playback plugin loaded')
    
    return true
  } catch (error) {
    console.error('Failed to load FLV scripts:', error)
    return false
  }
}

function playNormalVideoJs(url) {
  const videoPlayer = videojs('example-video', {})
  videoPlayer.play()
}

function playHls(url, config) {
  axios.post(config.endpoint, {
    VideoId: url,
    Token: '',
    Language: 'en',
    AppId: 101,
    AppVer: 1064
  })
    .then(response => {
      if (response.data.URL.includes('/5334773/')) {
        const playerElement = document.getElementById('player')
        playerElement.innerHTML = `<img style="width:100%;height:100%;" src="${playerConfig.value.poster}" class="offline-stream">`
      } else {
        playNormal(config.corsbypass + response.data.URL)
      }
    })
    .catch(error => {
      console.error(error)
      const playerElement = document.getElementById('player')
      playerElement.innerHTML = `<img style="width:100%;height:100%;" src="${playerConfig.value.poster}" class="error-stream">`
    })
}

function playIframe(url) {
  const playerElement = document.getElementById('player')
  playerElement.innerHTML += `<div class="container">
    <iframe scrolling="no" class="responsive-iframe" width="560" height="315" 
      src="${url}" frameborder="0" 
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
      allowfullscreen>
    </iframe>
  </div>`
}

function playSdp(url) {
  setTimeout(() => {
    const playerElement = document.getElementById('player')
    playerElement.innerHTML = `
      <section class="player_section">
        <video id="video" class="video-js vjs-theme-custom" controls autoplay playsinline 
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; object-fit: cover;">
        </video>
        <input type="hidden" name="signal_url" id="signal_url" value="${url}">
        <button id="play" style="display:none;">Play</button>
        <button id="stop" style="display:none;">Stop</button>
      </section>`

    const scripts = [
      '/plugin/jquery.js',
      '/plugin/adapter.js',
      '/plugin/common.js',
      '/plugin/sha256.js',
      '/plugin/md5.js',
      '/plugin/env.js',
      '/plugin/report.js',
      '/plugin/play.js'
    ]

    scripts.forEach(script => {
      const scriptElement = document.createElement('script')
      scriptElement.src = script
      document.body.appendChild(scriptElement)
    })
  }, 1000)
}

function playNormal(url) {
  console.log(`playing normal ${url}`)
  if (url.includes('.flv')) {
    playFlv(url)
  } else {
    playerConfig.value.source = url
    playerConfig.value.mimeType = detectMimeType(url)
    console.log('Player config:', playerConfig.value)
    
    // Check if container exists
    const container = document.getElementById('player')
    if (!container) {
      console.error('Player container not found!')
      return
    }
    
    // Initialize player
    try {
      player.value = new Clappr.Player(playerConfig.value)
      console.log('Player initialized:', player.value)
      
      // Add event listeners for debugging
      player.value.on(Clappr.Events.PLAYER_PLAY, () => {
        console.log('Player started playing')
      })
      
      player.value.on(Clappr.Events.PLAYER_ERROR, (error) => {
        console.error('Player error:', error)
      })
      
      player.value.on(Clappr.Events.PLAYER_READY, () => {
        console.log('Player is ready')
        player.value.play()
      })
    } catch (error) {
      console.error('Failed to initialize player:', error)
    }
  }
}

function playFlv(url) {
  // Load FLV scripts first
  loadFlvScripts().then(success => {
    if (!success) {
      console.error('Failed to load FLV scripts')
      return
    }

    // Check if container exists
    const container = document.getElementById('player')
    if (!container) {
      console.error('Player container not found!')
      return
    }

    // Clear the container
    container.innerHTML = ''

    // Use the same config as playNormal but with FLV specific settings
    const flvConfig = {
      autoPlay: false,
      mute: true,
      source: url,
      poster: playerConfig.value.poster,
      mimeType: 'video/flv',
      watermark: playerConfig.value.watermark,
      watermarkLink: playerConfig.value.watermark[0].imageLink,
      position: 'top-right',
      language: 'en',
      strings: {
        en: {
          default_error_title: 'Error',
          default_error_message: 'Stream Error - Please refresh or try another channel'
        }
      },
      plugins: [window.FLVJSPlayback, window.ClapprAds],
      ads: playerConfig.value.ads,  // Use the same ads configuration as normal player
      preload: 'true',
      height: '100%',
      width: '100%',
      parentId: '#player',
      fullscreen: true,
      fullscreenConfig: {
        allowFullscreen: true,
        allowFullscreenInteractive: true,
        allowFullscreenWithKeys: true
      },
      mediaControl: playerConfig.value.mediaControl
    }
    
    console.log('FLV Player config:', flvConfig)
    
    // Initialize player
    try {
      player.value = new Clappr.Player(flvConfig)
      console.log('FLV Player initialized:', player.value)
      
      // Add event listeners for debugging
      player.value.on(Clappr.Events.PLAYER_PLAY, () => {
        console.log('FLV Player started playing')
      })
      
      player.value.on(Clappr.Events.PLAYER_ERROR, (error) => {
        console.error('FLV Player error:', error)
      })
      
      player.value.on(Clappr.Events.PLAYER_READY, () => {
        console.log('FLV Player is ready')
        // Initialize ads plugin after player is ready
        if (window.ClapprAds) {
          const adsPlugin = new window.ClapprAds(player.value)
          adsPlugin.configure(flvConfig.ads)
          console.log('Ads plugin configured for FLV')
          
          // Start playing after ads plugin is configured
          player.value.play()
        }
      })

      // Add fullscreen event listeners
      player.value.on(Clappr.Events.PLAYER_FULLSCREEN, () => {
        console.log('Player entered fullscreen')
      })

      player.value.on(Clappr.Events.PLAYER_EXITFULLSCREEN, () => {
        console.log('Player exited fullscreen')
      })

      // Add ads event listeners for debugging
      player.value.on(Clappr.Events.ADS_PLAYER_READY, () => {
        console.log('Ads player is ready')
      })

      player.value.on(Clappr.Events.ADS_PLAYER_ERROR, (error) => {
        console.error('Ads player error:', error)
      })

      player.value.on(Clappr.Events.ADS_PLAYER_STARTED, () => {
        console.log('Ads playback started')
      })

      player.value.on(Clappr.Events.ADS_PLAYER_ENDED, () => {
        console.log('Ads playback ended')
        // Start playing the main content after ads
        player.value.play()
      })

      // Add specific pre-roll event listeners
      player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_STARTED, () => {
        console.log('Pre-roll ad started')
      })

      player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_ENDED, () => {
        console.log('Pre-roll ad ended')
      })

      player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_SKIPPED, () => {
        console.log('Pre-roll ad skipped')
      })
    } catch (error) {
      console.error('Failed to initialize FLV player:', error)
    }
  })
}

const detectMimeType = (url) => {
  if (url.includes('.m3u8')) {
    return 'application/x-mpegURL';
  }
  if (url.includes('.flv')) {
    return 'video/flv';
  }
  if (url.includes('.sdp')) {
    return 'application/sdp';
  }
  return 'application/sdp';
}
</script>

<template>
  <div id="player" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></div>
  <div id="ads_overlay"></div>
</template>

<style scoped>
*,
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Add watermark animation keyframes */
@keyframes watermarkOpacity {
  0% { opacity: 1; }
  14.58% { opacity: 1; } /* 35 seconds */
  15% { opacity: 0; }
  95.83% { opacity: 0; } /* 4 minutes */
  96.25% { opacity: 1; } /* 15 seconds */
  100% { opacity: 1; }
}

/* Add watermark animation class */
.animated-watermark {
  animation: watermarkOpacity 240s infinite !important;
  animation-timing-function: linear !important;
}

/* Ensure watermark is visible by default */
.clappr-watermark {
  opacity: 1 !important;
}

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#player {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  overflow: hidden;
}

#player video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#ads_overlay {
  position: absolute;
  width: 100%;
  bottom: 50px;
  z-index: 1000;
  left: 0;
  right: 0;
  margin: 0 auto;
}

#ads_overlay button {
  border: none;
  position: relative;
  cursor: pointer;
  background: 0 0;
  width: 50px;
  height: 30px;
  padding: 0;
  outline: 0;
  margin-left: 50%;
}

#ads_overlay .btn-paused {
  display: none !important;
}

/* Add styles for Clappr player container */
.clappr-container {
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow: hidden !important;
}

/* Ensure Clappr controls stay within bounds */
.clappr-controls {
  width: 100% !important;
  max-width: 100% !important;
  left: 0 !important;
  right: 0 !important;
}

/* Fullscreen styles */
.clappr-container.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 999999 !important;
}

.clappr-container.fullscreen video {
  width: 100vw !important;
  height: 100vh !important;
  object-fit: contain !important;
}
</style>
